app.controller('esEntityLookupICD10Controller', ['$scope', 'dictionaryModel',
    function ($scope, dictionaryModel) {
        $scope.$on(Event.DICTIONARY.GET_DICTIONARY_ELEMENT_DATA_PAGE.SUCCESS, function (event, dataPage, code) {
            if(code === Constant.DICTIONARY_CODE.ICD10) {
                $scope.items = dataPage.data;
                $scope.lookupInProgress = false;
            }
        });

        $scope.getData = function (s) {
            if(s) {
                var criteria = {rowsPerSheet: 10, searchPhrase: s};
                dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.ICD10, criteria);
                $scope.lookupInProgress = true;
            } else {
                $scope.items = [];
            }
        };

        $scope.getLabel = function(item) {
            if(item) {
                return item.value + ' ' + item.description;
            }
        };

    }
]);